import { ComparisonNudgeComms, ComparisonNudgeItem, IRemovePlanMessage, PlanDetails } from "@swiggy-private/cart-types";

export interface SubscriptionRenewalHandlers {
    navigateToDeeplinkGenericHelper: (url: string) => void;
    addSuperToCart: (planId: string, planType?: string) => void;
    removeSuperFromCart: (text?: string) => void;
}

export interface SubscriptionRenewalConfig {
    currentSid?: string;
    sessionKey?: string;
    isAnyModalVisible?: boolean;
}

export interface SubscriptionRenewalAnalytics {
    onImpressionSubscriptionRenewalPlanNudge: (planData: ComparisonNudgeItem) => void;
    onClickRemovePlanCta: (planData: ComparisonNudgeItem) => void;
    onClickAddPlanCta: (planData: ComparisonNudgeItem) => void;
    onClickComparePlanCta: (planData: ComparisonNudgeItem) => void;
    onImpressionSubscriptionRenewalRemovalCta: (planData: ComparisonNudgeItem) => void;
    onImpressionPlanRemovalHalfcard: (context: string) => void;
    onClickRemovePlanRemovalHalfcard: (context: string) => void;
}

export interface SubscriptionRenewalNudgeAnalytics {
    subscriptionRenewalAnalytics: SubscriptionRenewalAnalytics;
}

export interface SubscriptionRenewalNudgeProps {
    comparisonNudgeComms?: ComparisonNudgeComms;
    handlers: SubscriptionRenewalHandlers;
    analyticsEvents: SubscriptionRenewalNudgeAnalytics;
    removePlanMessage: IRemovePlanMessage;
    planDetails: PlanDetails;
    isTopPositioned: boolean;
}

export enum BUTTON_VARIANT_TYPE {
    ADD_PLAN = "ADD_PLAN",
    REMOVE_PLAN = "REMOVE_PLAN",
}
